import { useCallback, useMemo } from 'react'
import HostHome from 'src/pages/HostHome'
import Leaderboard from 'src/pages/Leaderboard'
import Settings from 'src/pages/Settings'
import Session from 'src/pages/Session'
import AllSessions from 'src/components/AllSessions/AllSessions'
import NavigationHeader from './NavigationHeader'
import {
  useAppSelector,
  useUpdateShowBadges,
  useGetHostContext,
  useOnParticipantChange,
  useUpdateSession,
  useVirtualForeground,
  useAutoEndSession,
  useSendAppInvitation,
} from 'src/hooks'
import { selectCurrentPage, selectPageProps } from 'src/app/page'
import FullScreenSpinner from 'src/components/FullScreenSpinner'
import { selectModalLoading } from 'src/app/modal'
import { useGetAllSessionsQuery } from 'src/app/appApiQueries'
import {selectShowBadges, selectShowFTE} from 'src/app/hostSettings'
import { selectParticipantBadges } from 'src/app/session'
import Onboarding from "../../pages/Onborading";

function HostNavigation() {
  const currentPage = useAppSelector(selectCurrentPage)
  const isModalLoading = useAppSelector(selectModalLoading)
  const pageProps = useAppSelector(selectPageProps)
  // need loading from fetching the active session info
  const isLoading = useGetHostContext()
  const showBadges = useAppSelector(selectShowBadges)
  // we must memoize re-selectors if they will appear in different component instances
  const selectParticipantBadgesMemo = useMemo(() => selectParticipantBadges, [])
  const myBadges = useAppSelector((state) => selectParticipantBadgesMemo(state))

  // obtain the initial state of showFTE
  const showFTE = useAppSelector(selectShowFTE)

  // these hooks need to sit above all the host pages to stay active
  useVirtualForeground(showBadges, myBadges)
  useUpdateShowBadges()
  useUpdateSession()
  useOnParticipantChange(showBadges)
  useSendAppInvitation(showBadges, isLoading)
  const isAutoEndLoading = useAutoEndSession()

  const { isLoading: isAllSessionLoading, isFetching } =
    useGetAllSessionsQuery('AllSessions')

  const renderPage = useCallback(() => {
    switch (currentPage) {
      case 'Settings':
        return <Settings />
      case 'Leaderboard':
        return <Leaderboard />
      case 'Session': {
        // only go to the session if we have props (TS complains if we dont)
        if (pageProps) return <Session {...pageProps} />
        else return <HostHome />
      }
      case 'AllSessions':
        return <AllSessions />
      default:
        return <HostHome />
    }
  }, [currentPage, pageProps])

  // track loading of the all sessions refetch only on the home or all sessions page
  const isAllSessionFetching =
    isFetching && (currentPage === 'AllSessions' || currentPage === 'Home')

  return (
    <div className="sm:flex">
      <NavigationHeader />

      <div className="p-4 w-full sm:w-mainView pb-16">
        {isLoading ||
        isAutoEndLoading ||
        isModalLoading ||
        isAllSessionLoading ||
        isAllSessionFetching ? (
          <FullScreenSpinner styles="h-[calc(100vh-180px)] sm:h-screen" />
        ) : showFTE ? (
            <Onboarding/>
        ) : !showFTE && (
          renderPage()
        )}
      </div>
    </div>
  )
}

export default HostNavigation
